import React from 'react'
import { createContextWithHook } from '@chilipiper/utils'
import { RootMenuTriggerState } from '@react-stately/menu'

export const { ActionListBaseProvider, useActionListContext } = createContextWithHook<{
  listRef: React.RefObject<HTMLUListElement | null>
  menuTriggerState: RootMenuTriggerState
}>()('ActionList')
